import React from 'react';

// tone: neutral | positive | warning | danger | accent
export function Badge({ tone = 'neutral', children }) {
  return <span className={`crm-badge crm-badge-${tone}`}>{children}</span>;
}

// Mapeia status técnico (o que a API devolve) pra {label em português, tone}.
// Cobre os status já usados nos domínios do CRM — módulos podem passar um
// mapa próprio se tiverem um status que não está aqui.
const MAPA_STATUS_PADRAO = {
  ATIVO: { label: 'Ativo', tone: 'positive' },
  ativo: { label: 'Ativo', tone: 'positive' },
  INATIVO: { label: 'Inativo', tone: 'neutral' },
  inativo: { label: 'Inativo', tone: 'neutral' },
  PAGO: { label: 'Pago', tone: 'positive' },
  RECEBIDO: { label: 'Recebido', tone: 'positive' },
  CONFIRMADO: { label: 'Confirmado', tone: 'positive' },
  PENDENTE: { label: 'Pendente', tone: 'warning' },
  PARCIAL: { label: 'Parcial', tone: 'warning' },
  // Correção pós-QA (bug crítico): antes uma conta parcialmente paga E
  // vencida virava só "Vencido" — escondia que uma parte já tinha entrado.
  PARCIAL_VENCIDO: { label: 'Parcial · vencido', tone: 'danger' },
  ATRASADO: { label: 'Atrasado', tone: 'danger' },
  VENCIDO: { label: 'Vencido', tone: 'danger' },
  CANCELADO: { label: 'Cancelado', tone: 'neutral' },
  ARQUIVADO: { label: 'Arquivado', tone: 'neutral' },
  BAIXADO: { label: 'Baixado', tone: 'neutral' },
  DISPONIVEL: { label: 'Disponível', tone: 'positive' },
  EM_USO: { label: 'Em uso', tone: 'accent' },
  INSTALADO: { label: 'Instalado', tone: 'accent' },
  EM_MANUTENCAO: { label: 'Em manutenção', tone: 'warning' },
  DEFEITUOSO: { label: 'Defeituoso', tone: 'danger' },
  EM_ANDAMENTO: { label: 'Em andamento', tone: 'accent' },
  PLANEJAMENTO: { label: 'Planejamento', tone: 'neutral' },
  PAUSADO: { label: 'Pausado', tone: 'warning' },
  CONCLUIDO: { label: 'Concluído', tone: 'positive' },
  CONCLUIDA: { label: 'Concluída', tone: 'positive' },
};

export function StatusBadge({ status, mapa }) {
  const info = (mapa && mapa[status]) || MAPA_STATUS_PADRAO[status] || { label: status, tone: 'neutral' };
  return <Badge tone={info.tone}>{info.label}</Badge>;
}

export default Badge;
